import { createRoute } from '@tanstack/react-router';

import { createTenantApp } from '@/app/createTenantApp';
import { useAuth } from '@shared/auth/Authentication.hooks';
import { homeSearchSchema } from './home/Home';

import Home from './home/Home';
import Collection from './collection/Collection';
import Issue from '@pages/issue/Issue';

export const router = createTenantApp({
	home: {
		path: '/',
		validateSearch: homeSearchSchema,
		component: AuthHome,
	},
	routes: ['issue', 'issueArticle', 'drafts', 'favorite', 'previewView'],
	// `issues` (plain Issue component, no $id, no auth) and `collections/$id`
	// are both morningstar-exclusive -- no other template has either.
	custom: (rootRoute) => [
		createRoute({
			getParentRoute: () => rootRoute,
			component: Issue,
			path: 'issues',
		}),
		createRoute({
			getParentRoute: () => rootRoute,
			component: AuthCollection,
			path: 'collections/$id',
		}),
	],
	devtools: true,
});

function AuthHome() {
	useAuth({ redirect: false });
	return (
		<>
			<Home />
		</>
	);
}

function AuthCollection() {
	useAuth({ redirect: true });
	return (
		<>
			<Collection />
		</>
	);
}
